module.exports = __webpack_public_path__ + "img/home-case-04.6a22a456.png";